<template>
  <v-dialog v-model="popupShow" persistent max-width="400">
    <v-card>
      <v-card-title center class="display-1 text-center">
        <v-flex v-if="status == 'failure'" class="my-2">Failure!</v-flex>
        <v-flex v-if="status == 'success'" class="my-2">Success!</v-flex>
      </v-card-title>
      <v-card-text v-if="status == 'failure'" class="black--text text-center py-1">
        <p class="font-weight-medium body-1">We were unable to process your payment.</p>
        <div
          v-if="orderId != null"
          class="font-weight-medium body-1 mb-3"
        >Order ID: {{this.orderId}}</div>
        <p class="font-weight-medium body-1">Try again later.</p>
      </v-card-text>
      <v-card-text v-if="status == 'success'" class="black--text text-center py-1">
        <p class="font-weight-medium body-1">Tickets were successfully purchased!</p>
        <div v-if="showEmail && email != null" class="font-weight-medium body-1 mb-3">
          Invoice was sent to:
          <div class="font-weight-bold">{{this.email}}</div>
        </div>
        <div
          v-if="orderId != null"
          class="font-weight-medium body-1 mb-3"
        >Order ID: {{this.orderId}}</div>
        <p class="font-weight-medium body-1">See you at the conference.</p>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-flex justify="center">
          <v-btn
            class="mb-3"
            width="100"
            color="success"
            @click="closePopup();popupShow = false;"
          >Ok</v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StatusPopup",
  props: {
    status: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: false
    },
    orderId: {
      type: String,
      required: false
    },
        showEmail: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      popupShow: true
    };
  },
  methods: {
    closePopup() {
      this.$emit("change", {});
    }
  }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
</style>
